'use strict';


module.exports = ['$rootScope', '$state', '$q', 'translateFilter', 'toastService', function ($rootScope, $state, $q, translateFilter, toastService) {
        var errorHandler = {};

        var status200 = 200;
        var status400 = 400;
        var status403 = 403;
        var status500 = 500;

        errorHandler.handle = function (error, successMessage, errorMessage) {
            //TODO: TESTARE
            var deferred = $q.defer();
            var errMsg = errorMessage;

            var validationErrors = [];

            if (error) {
                if (error.status)
                {
                    switch (true) {
                        case (error.status === status200):
                            //SUCCESS                        
                            toastService.createSuccessToast(successMessage);

                            break;
                        case (error.status >= status500):       //OK
                            //INTERNAL SERVER ERROR
                            if (!errMsg)
                                errMsg = translateFilter('AstralSituationRecord.error.reloadPage');
                            toastService.createErrorToast(errMsg);

                            break;

                        case (error.status === status400):     //OK
                            //BAD REQUEST 

                            if (error && error.data && error.data.fieldErrors) {
                                //parsing errori di validazione
                                angular.forEach(error.data.fieldErrors, function (error) {
                                    if (error) {
                                        validationErrors[error.field.replace(".", "_").replace("[", "").replace("]", "")] = translateFilter('AstralSituationRecord.' + error.message);
                                    }
                                });

                            } else {
                                if (error && error.data && error.data.description) {
                                    toastService.createErrorToast(error.data.description);
                                }
                            }

                            break;
                        case (error.status== status403):
                            break;  //già gestito a livello globale da UAA
                        case (error.status > status400): //ok
                            //redirect sulla login
                            if (!errMsg)
                                errMsg = translateFilter('AstralSituationRecord.error.expiredSession');
                            toastService.createErrorToast(errMsg);
                            $state.go("login");

                            break;
                        default:
                            if (!errMsg)
                                errMsg = translateFilter('AstralSituationRecord.error');
                            toastService.createErrorToast(errMsg);

                    }

                } else {
                    if (!errMsg)
                        errMsg = translateFilter('AstralSituationRecord.error');
                    toastService.createErrorToast(errMsg);

                }
            } else {
                if (!errMsg)//OK
                    errMsg = translateFilter('AstralSituationRecord.error');
                toastService.createErrorToast(errMsg);
            }
            deferred.resolve(validationErrors);

            return deferred.promise;
        }
        ;

        errorHandler.getValidationErrorFieldName = function (listName, index, propertyName) {
                    var fieldName = listName;
                    if (index !== undefined)
                        fieldName = fieldName + index;
                    if (propertyName)
                        fieldName = fieldName + "_" + propertyName;

                    return fieldName;
                }

        errorHandler.status200 = status200;
        errorHandler.status400 = status400;
        errorHandler.status500 = status500;

        return errorHandler;

    }];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/services/errorHandlerService.js
// module id = 257
// module chunks = 0